import React from 'react';
import './flex-filler.scss';

const FlexFiller = () => <div styleName="flex-filler" />;

export default FlexFiller;
